module.exports = __webpack_public_path__ + "img/avatar-5.38acf08c.png";